export const TemplateRoutes = {
  Overview: 'overview',
  Layout: 'layout',
  Create: 'create',
} as const;
